import { Outlet } from "react-router-dom";
import Navbar from "../components/Header/Navbar";
import Footer from "../components/Header/Footer";
// import SignInModel from "../pages/Login/SignInModel";
// import { useSelector } from "react-redux";
import useSessionMonitor from "../hooks/useSessionMonitor";
import GlobalAuthLoader from "../components/Login/GlobalAuthLoader";
import ScrollToTop from "../components/Common/ScrollToTop";
// import AuthModelHOC from "../components/Samples/AuthModelHOC";
// import {AuthModelBaseComp} from "../components/Samples/AuthModelBaseComp";
// import { APIProvider } from '@vis.gl/react-google-maps';
// import { CONFIGURATIONS } from "../config/envConfig";

const Root = () => {
  // const { isSignInModalOpen } = useSelector((state) => state.auth);

  // Initialize the session monitor
  useSessionMonitor();
  // console.log('from root', CONFIGURATIONS.GOOGLE_MAPS_API_KEY);

  // const AuthPopUp = AuthModelHOC(AuthModelBaseComp);

  return (
    // <APIProvider
    //   apiKey={CONFIGURATIONS.GOOGLE_MAPS_API_KEY}
    //   onLoad={() => console.log('Maps API has loaded.')}
    //   libraries={['places', 'geometry']} // Optional: preload extra libraries
    // >
    <div className="flex flex-col min-h-screen min-w-[320px]">
      <GlobalAuthLoader />
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
      </div>

      {/* Spacer to push content below the navbar */}
      <div className="h-[65px]" />
      <main>
        {/* Handle Sign In Modal */}
        {/* <AuthPopUp isOpen={isSignInModalOpen} /> */}
        <ScrollToTop />
        <Outlet />
      </main>
      <Footer />
    </div>
    // </APIProvider>
  );
};

export default Root;
